import { FC, RefObject } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Button } from '@/atoms/Button'
import { PayItForwardOutlineIcon } from '@/atoms/Icons/PayItForwardOutlineIcon'
import { useOnScreen } from '@/utils/ScreenUtils'
import { useTranslate } from '@/utils/translate/translate-client'

interface FloatingPifButtonProps {
  targetRef: RefObject<HTMLElement>
}

export const FloatingPifButton: FC<FloatingPifButtonProps> = ({ targetRef }) => {
  const { t } = useTranslate('pif')
  const { isIntersecting } = useOnScreen(targetRef)

  const handleClick = () => {
    targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <AnimatePresence>
      {!isIntersecting && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { type: 'tween', duration: 0.3 } }}
          exit={{ y: 100, opacity: 0, transition: { type: 'tween', duration: 0.2 } }}
          className="fixed inset-x-0 bottom-0 z-50 p-4 md:hidden"
          style={{
            background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)',
          }}
        >
          <Button
            onClick={handleClick}
            className="ml-auto flex w-fit items-center justify-center gap-2"
            variant="oxide-primary"
            size="sm"
          >
            <PayItForwardOutlineIcon size={20} color="white" />
            {t('payItForward', 'Pay it Forward')}
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
